import { Stack } from '../../../../core/structures';

export class HistoryService<T> {

  private _historyActionsStack = new Stack<{ current: T, previous: T }>();
  private _revertedActionsStack = new Stack<{ current: T, previous: T }>();

  /**
   * Used to add action to history stack and clear reverted history stack
   * @param clearRevertedHistoryStack - if true, will clear reverted history stack, shouldn't be used for redo
   * @param current - current state of object
   * @param previous - previous state of object
   */
  public addToHistory(
    current: T,
    previous: T,
    clearRevertedHistoryStack: boolean
  ): void {
    this._historyActionsStack.push({current, previous});

    if (clearRevertedHistoryStack) {
      this._revertedActionsStack = new Stack<{ current: any, previous: any }>();
    }
  }

  /**
   * Used to when object during undo action has been modified the way that redo action will not be the same as before undo
   */
  public addToRevertedHistory(
    current: T,
    previous: T,
  ): void {
    this._revertedActionsStack.push({current, previous});
  }

  public undo(): { current: any, previous: any } {
    return this._historyActionsStack.pop() ?? null;
  }

  public redo(): { current: any, previous: any } {
    return this._revertedActionsStack.pop() ?? null;
  }
}
